// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IVersionDto } from './IVersionDto';
import {
    IVersionDtoFromJSON,
    IVersionDtoFromJSONTyped,
    IVersionDtoToJSON,
    IVersionDtoToJSONTyped,
} from './IVersionDto';

/**
 * 
 * @export
 * @interface IInterestRateTemplateDto
 */
export interface IInterestRateTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof IInterestRateTemplateDto
     */
    id?: number;
    /**
     * 
     * @type {Array<IVersionDto>}
     * @memberof IInterestRateTemplateDto
     */
    versions?: Array<IVersionDto>;
    /**
     * 
     * @type {string}
     * @memberof IInterestRateTemplateDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IInterestRateTemplateDto
     */
    organization_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IInterestRateTemplateDto
     */
    duration_start_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IInterestRateTemplateDto
     */
    duration_end_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IInterestRateTemplateDto
     */
    org_path?: string;
}

/**
 * Check if a given object implements the IInterestRateTemplateDto interface.
 */
export function instanceOfIInterestRateTemplateDto(value: object): value is IInterestRateTemplateDto {
    return true;
}

export function IInterestRateTemplateDtoFromJSON(json: any): IInterestRateTemplateDto {
    return IInterestRateTemplateDtoFromJSONTyped(json, false);
}

export function IInterestRateTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInterestRateTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'versions': json['versions'] == null ? undefined : ((json['versions'] as Array<any>).map(IVersionDtoFromJSON)),
        'name': json['name'] == null ? undefined : json['name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'duration_start_on': json['duration_start_on'] == null ? undefined : (new Date(json['duration_start_on'])),
        'duration_end_on': json['duration_end_on'] == null ? undefined : (new Date(json['duration_end_on'])),
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
    };
}

export function IInterestRateTemplateDtoToJSON(json: any): IInterestRateTemplateDto {
    return IInterestRateTemplateDtoToJSONTyped(json, false);
}

export function IInterestRateTemplateDtoToJSONTyped(value?: IInterestRateTemplateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'versions': value['versions'] == null ? undefined : ((value['versions'] as Array<any>).map(IVersionDtoToJSON)),
        'name': value['name'],
        'organization_id': value['organization_id'],
        'duration_start_on': value['duration_start_on'] == null ? undefined : ((value['duration_start_on']).toISOString()),
        'duration_end_on': value['duration_end_on'] == null ? undefined : ((value['duration_end_on']).toISOString()),
        'org_path': value['org_path'],
    };
}

